import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { languageCode } from '../tools';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    react: {
      useSuspense: false,
    },
    lng: languageCode,
    load: 'all',
    fallbackLng: false,
    ns: ['common', 'home'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    lowerCaseLng: true,
  });

export default i18n;
